import { memo } from 'react'
import { SxProps } from '@mui/material'
import { Box } from '@/components/Layout'
import { dividerStyles as styles } from './Divider.style'

//Tried to use hr tag but facing issue with styles
interface DividerProps {
  sx?: SxProps
}
const Divider = ({ sx }: DividerProps) => {
  return <Box sx={{ ...styles.dividerStyles, ...sx } as SxProps} component={'div'} />
}

export default memo(Divider)
